import styled from 'styled-components/macro';

export const AdminNav = styled.nav`
  margin: 1em 0;
`;

export * from '../../common/elements/Staff';
